export default "__VITE_ASSET__CiXSlIKB__"